// Shared constants and helpers for ChecklistsV2 components.
import { getAccessToken } from '@/lib/tokenStore';

export const API_V2 = `${process.env.REACT_APP_BACKEND_URL}/api/v2`;
export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const MAAND_NAMEN = [
  '', 'januari', 'februari', 'maart', 'april', 'mei', 'juni',
  'juli', 'augustus', 'september', 'oktober', 'november', 'december',
];

/** Check if template is a meterstand checklist */
export const isMeterstandTemplate = (naam) =>
  (naam || '').toLowerCase().trim() === 'meterstanden';

/** Determine target month for meterstand registration.
 * First 7 days of month → previous month, otherwise current month.
 */
export const bepaalVerbruikMaand = () => {
  const now = new Date();
  const dag = now.getDate();
  if (dag <= 7) {
    const m = now.getMonth(); // 0-indexed
    if (m === 0) return { jaar: now.getFullYear() - 1, maand: 12 };
    return { jaar: now.getFullYear(), maand: m };
  }
  return { jaar: now.getFullYear(), maand: now.getMonth() + 1 };
};

export const hdrs = () => {
  const t = getAccessToken();
  return t
    ? { Authorization: `Bearer ${t}`, 'Content-Type': 'application/json' }
    : { 'Content-Type': 'application/json' };
};

export const authOnly = () => {
  const t = getAccessToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const imgUrl = (u) => (u?.startsWith('/') ? `${BACKEND}${u}` : u);

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString('nl-NL', { day: '2-digit', month: 'long', year: 'numeric' }) : '';

export const fmtDateShort = (d) =>
  d ? new Date(d).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit' }) : '';

export const scoreColor = (p) => {
  if (p == null) return 'text-slate-400';
  if (p >= 85) return 'text-green-600';
  if (p >= 70) return 'text-amber-600';
  return 'text-red-600';
};

export const scoreBg = (p) => {
  if (p == null) return 'bg-slate-100 text-slate-500';
  if (p >= 85) return 'bg-green-100 text-green-700';
  if (p >= 70) return 'bg-amber-100 text-amber-700';
  return 'bg-red-100 text-red-700';
};

export const statusBadge = (status, teLaat) => {
  if (status === 'open') return { label: 'Open', cls: 'bg-blue-100 text-blue-700' };
  if (status === 'verlopen') return { label: 'Verlopen', cls: 'bg-red-100 text-red-700' };
  if (status === 'gemist') return { label: 'Gemist', cls: 'bg-slate-100 text-slate-500' };
  if (status === 'ingevuld_te_laat' || teLaat) return { label: 'Te laat', cls: 'bg-amber-100 text-amber-700' };
  return { label: 'Ingevuld', cls: 'bg-green-100 text-green-700' };
};
